const aiAssistant = (() => {
  const BACKEND = window.AI_BACKEND_URL || 'https://dilsebol-ai-backend-production.up.railway.app';
  const SESSION_KEY = 'dilsebol_chat_history';
  const MOCKUP_STATE_KEY = 'dilsebol_mockup_state';

  let sessionHistory = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '[]');
  let chatGeneration = 0;
  let chatInFlight = false;

  const PAGE_SIZE = 5;

  const thread = () => document.getElementById('ai-thread');
  const input = () => document.getElementById('ai-input');
  const sendBtn = () => document.getElementById('ai-send-btn');

  function init() {
    document.getElementById('ai-input').addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });

    document.getElementById('ai-clear-btn')?.addEventListener('click', clearChat);

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        sessionStorage.setItem('dilsebol_cart_token', cart.token);
        sessionStorage.setItem('dilsebol_cart_count', cart.item_count);
      })
      .catch(() => {});

    if (sessionHistory.length > 0) {
      sessionHistory.forEach(msg => {
        if (msg.role === 'user') {
          let displayMsg = msg.content;
          if (msg.content.includes('<shade_selected>')) {
              const start = msg.content.indexOf('<shade_selected>') + '<shade_selected>'.length;
              const end = msg.content.indexOf('</shade_selected>');
              displayMsg = msg.content.substring(start, end).trim();
          }
          appendUserBubble(displayMsg);
        } else {
          const cleanReply = stripTags(msg.content);
          const bulkEnquiry = parseBulkEnquiry(msg.content);
          const retiredBulkEnquiry =
            bulkEnquiry && bulkEnquiry.status !== 'pending';

          const pendingMockupChoice =
            msg.content.includes('<mockup_choices/>');
          const finishedMockupChoice =
            msg.content.includes('<mockup_finished/>');

          // A completed choice is replaced by its chosen-product outcome.
          const quoteHandoff = parseHandoff(msg.content);
          const retiredQuoteForm =
            quoteHandoff?.handoff_type === 'quote_form' &&
            quoteHandoff.status === 'retired';

          if (
            cleanReply &&
            !finishedMockupChoice &&
            !retiredBulkEnquiry &&
            !retiredQuoteForm
          ) {

            appendAssistantBubble(
              pendingMockupChoice ? mockupIntro(cleanReply) : cleanReply,
              true
            );
          }


          // Only replay product cards if this is the LAST assistant message
          // with products — not mid-conversation ones
          const isLastMessage = sessionHistory[sessionHistory.length - 1] === msg
            || (sessionHistory[sessionHistory.length - 1].role === 'user'
                && sessionHistory[sessionHistory.length - 2] === msg);
          const products = parseProducts(msg.content);
          if (bulkEnquiry?.status === 'pending' && isLastMessage) {
            showBulkEnquiryForm(bulkEnquiry, msg);
          }

          const savedHandoff = parseHandoff(msg.content);
          if (
            isLastMessage &&
            savedHandoff?.handoff_type === 'quote_form' &&
            (savedHandoff.status ?? 'pending') === 'pending'
          ) {
            dispatchHandoff(savedHandoff, msg);
          }

          if (products.length > 0 && isLastMessage && !finishedMockupChoice) {
            appendProductCards(products, products.length, 0);
          }


          const clarify = parseClarify(msg.content);
          if (clarify) appendClarifyButtons(clarify);

          if (msg.content.includes('<collect_email/>')) {
            appendEmailCollect(msg);
          }

        }
      });
      scrollToBottom();
    }
    syncHeaderStartOver();

    const placeholders = [
      'e.g. I need 200 polo t-shirts with our logo...',
      'e.g. White round-neck t-shirts for 50 employees...',
      'e.g. New joiner kits...',
      'e.g. Mugs with logo print for office staff...',
    ];
    const inputEl = input();
    let placeholderIndex = 0;
    setInterval(() => {
      placeholderIndex = (placeholderIndex + 1) % placeholders.length;
      inputEl.placeholder = placeholders[placeholderIndex];
    }, 3000);

  function checkCartOnReturn() {
      if (sessionStorage.getItem('dilsebol_ref') !== 'assistant') return;
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const prevCount = parseInt(sessionStorage.getItem('dilsebol_cart_count') || '0');
          if (cart.item_count > prevCount) {
            sessionStorage.setItem('dilsebol_cart_count', cart.item_count);
            const cartMsg = document.createElement('div');
            cartMsg.className = 'ai-bubble assistant';
            cartMsg.innerHTML = `Your items are in the cart. Ready to explore anything else? <a href="/cart" style="display:inline-block;margin-left:8px;background:#CC3333;color:#fff;padding:5px 14px;border-radius:20px;font-size:12px;font-weight:600;text-decoration:none;font-family:var(--font-body-family,sans-serif);">View Cart</a>`;
            thread().appendChild(cartMsg);
            scrollToBottom();
          }
        })
        .catch(() => {});
    }

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'visible') return;
      checkCartOnReturn();
    });

    window.addEventListener('focus', () => {
      checkCartOnReturn();
    });

    // Fix for mobile back-navigation (bfcache)
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        checkCartOnReturn();
      }
    });
  }

  function stripTags(content) {
    return content
      .replace(/<search_state>[\s\S]*?<\/search_state>/g, '')
      .replace(/<products>[\s\S]*?<\/products>/g, '')
      .replace(/<handoff>[\s\S]*?<\/handoff>/g, '')
      .replace(/<clarify>[\s\S]*?<\/clarify>/g, '')
      .replace(/<collect_email\/>/g, '')
      .replace(/<resolved_keyword>[\s\S]*?<\/resolved_keyword>/g, '')
      .replace(/<mockup_pending\/>/g, '')
      .replace(/<mockup_choices\/>/g, '')
      .replace(/<mockup_finished\/>/g, '')
      .replace(/<bulk_enquiry>[\s\S]*?<\/bulk_enquiry>/g, '')
      .trim();
  }

  function syncHeaderStartOver() {
    const headerButton = document.getElementById('ai-clear-btn');
    if (headerButton) {
      headerButton.hidden = !thread().querySelector('.ai-start-over-link');
    }
  }
  function clearChat() {
    // Invalidate any chat response belonging to the previous conversation.
    chatGeneration += 1;
    chatInFlight = false;
    setLoading(false);

    sessionHistory = [];

    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.removeItem(MOCKUP_STATE_KEY);
    const t = thread();
    while (t.firstChild) t.removeChild(t.firstChild);
    syncHeaderStartOver();
    appendAssistantBubble('👋 Hi! I\'m ABAI (Automated Basic AI) - your shopping assistant. Tell me what you\'re looking for: T-shirts, shirts, caps, mugs, bottles, backpacks, new joiner kits, etc and I\'ll show you options with pricing instantly.', false);
    scrollToBottom();
  }

  async function sendMessage(overrideText = null) {
    const msg = overrideText || input().value.trim();
    if (!msg || chatInFlight) return;
    if (thread().querySelector('.ai-bulk-enquiry-form[data-sending="true"]')) {
      return;
    }

    chatInFlight = true;
    const requestGeneration = chatGeneration;

    retirePendingBulkEnquiries();

    // A new message after product choices finishes that mock-up choice.
    if (sessionStorage.getItem(MOCKUP_STATE_KEY) === 'choosing_product') {
      finishMockupChoice();
    }


    let displayMsg = msg;

    if (msg.includes('<shade_selected>')) {
        const start = msg.indexOf('<shade_selected>') + '<shade_selected>'.length;
        const end = msg.indexOf('</shade_selected>');
        displayMsg = msg.substring(start, end).trim();
    }
    if (msg.startsWith('<colour_selected>') &&
        msg.endsWith('</colour_selected>')) {
      displayMsg = msg
        .slice('<colour_selected>'.length, -'</colour_selected>'.length)
        .trim();
    }

    appendUserBubble(displayMsg);

    input().value = '';
    setLoading(true);

    sessionHistory.push({ role: 'user', content: msg });
    saveSession();

    const loadingEl = appendLoadingBubble();

    try {
      const latestAssistant = [...sessionHistory].reverse().find(
        message => message.role === 'assistant'
      );

      const historyToSend = sessionHistory.slice(-10).map(m => {

        if (m.role !== 'assistant') return m;
        const cleaned = m.content
          .replace(/<products>[\s\S]*?<\/products>/g, '')
          .replace(/<handoff>[\s\S]*?<\/handoff>/g, '')
          .replace(/<clarify>[\s\S]*?<\/clarify>/g, '')
          .replace(/<collect_email\/>/g, '')
          .replace(/<mockup_pending\/>/g, '')
          .replace(/<mockup_choices\/>/g, '')
          .replace(/<mockup_finished\/>/g, '')
          .replace(/<bulk_enquiry>[\s\S]*?<\/bulk_enquiry>/g, '')
          .trim();
        let choiceRecord = '';

        if (m === latestAssistant) {
          const matches = [
            ...m.content.matchAll(/<clarify>([\s\S]*?)<\/clarify>/g)
          ];

          if (matches.length === 1) {
            try {
              const payload = JSON.parse(matches[0][1]);
              const compact = {};
              let valid =
                payload !== null &&
                typeof payload === 'object' &&
                !Array.isArray(payload);

              for (const field of [
                'options', 'more_options', 'remaining_options'
              ]) {
                const values = payload?.[field] ?? [];

                if (
                  !Array.isArray(values) ||
                  values.length > 250 ||
                  values.some(value =>
                    typeof value !== 'string' ||
                    value.length > 200 ||
                    /[<>\r\n]/.test(value)
                  )
                ) {
                  valid = false;
                  break;
                }

                compact[field] = values;
              }

              if (valid) {
                choiceRecord =
                  '\n<clarify>' +
                  JSON.stringify(compact) +
                  '</clarify>';
              }
            } catch (error) {
              // Invalid clarification data is not carried forward.
            }
          }
        }

        return {
          role: m.role,
          content: cleaned + choiceRecord
        };

      });

      const res = await fetch(`${BACKEND}/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: historyToSend })
      });

      const data = await res.json();

      // Start over makes responses from the old conversation obsolete.
      if (requestGeneration !== chatGeneration) return;

      loadingEl.remove();

      if (!res.ok || typeof data?.reply !== 'string') {
        throw new Error('Chat returned an invalid response');
      }

      const reply = data.reply;

      const handoff = parseHandoff(reply);
      const isBulkHandoff = handoff?.handoff_type === 'bulk_lead';


      if (reply.includes('<mockup_pending/>')) {
        sessionStorage.setItem(MOCKUP_STATE_KEY, 'active');
      }

      const products = parseProducts(reply);
      const mockupResults =
        products.length > 0 &&
        sessionStorage.getItem(MOCKUP_STATE_KEY) === 'active';

      const cleanReply = stripTags(reply);

      // For a bulk submission, dispatchHandoff supplies the actual outcome.
      // Don't display or save an unverified backend acknowledgement.
      if (!isBulkHandoff) {
        if (cleanReply) {
          appendAssistantBubble(
            mockupResults ? mockupIntro(cleanReply) : cleanReply, true
          );
        }

        sessionHistory.push({
          role: 'assistant',
          content: mockupResults ? reply + '\n<mockup_choices/>' : reply
        });
        saveSession();
      }

      const bulkEnquiry = parseBulkEnquiry(reply);
      if (bulkEnquiry?.status === 'pending') {
        showBulkEnquiryForm(
          bulkEnquiry,
          sessionHistory[sessionHistory.length - 1]
        );
      }

      if (products.length > 0) {
        if (mockupResults) {
          sessionStorage.setItem(MOCKUP_STATE_KEY, 'choosing_product');
        }
        appendProductCards(products, products.length, 0);
      }

      const clarify = parseClarify(reply);
      if (clarify) appendClarifyButtons(clarify);

      if (handoff) await dispatchHandoff(handoff);

      if (requestGeneration !== chatGeneration) return;

      if (reply.includes('<collect_email/>')) {
        appendEmailCollect(sessionHistory[sessionHistory.length - 1]);
      }

    } catch (err) {
      if (requestGeneration !== chatGeneration) return;

      loadingEl.remove();
      appendAssistantBubble(
        'Sorry, I had trouble connecting. Please try again.',
        false
      );
    } finally {
      // An old request must not unlock a newer conversation's request.
      if (requestGeneration === chatGeneration) {
        chatInFlight = false;
        setLoading(false);
      }
    }
  }


  // ── Quote Flow ────────────────────────────────────────────────────────────

  function setSavedQuoteState(formDiv, status, quantity = undefined) {
    const sourceMessage = formDiv?._quoteSourceMessage;

    // Ordinary card forms do not have a saved chat handoff.
    if (!sourceMessage) return true;

    // Never write an old form back into a cleared conversation.
    if (!sessionHistory.includes(sourceMessage)) return false;

    const handoff = parseHandoff(sourceMessage.content);
    if (handoff?.handoff_type !== 'quote_form') return false;

    const currentStatus = handoff.status ?? 'pending';
    const allowedTransitions = {
      pending: ['pending', 'sending', 'retired'],
      sending: ['pending', 'completed', 'unconfirmed'],
      completed: [],
      unconfirmed: [],
      retired: []
    };

    if (!allowedTransitions[currentStatus]?.includes(status)) {
      return false;
    }

    const messages = {
      pending:
        'Please complete the quote form below. ' +
        'Nothing has been submitted yet.',
      sending:
        'A quote request was started. Its delivery has not yet been ' +
        'confirmed. Please contact the team before submitting again.',
      completed:
        'Your quotation has been sent. Please check your inbox.',
      unconfirmed:
        'Quote delivery couldn’t be confirmed. ' +
        'Please contact the team before submitting again.',
      retired:
        'This quote form is no longer active. ' +
        'Closing this form did not submit a quotation.'

    };

    if (!Object.prototype.hasOwnProperty.call(messages, status)) {
      return false;
    }

    const savedQuantity = quantity === undefined
      ? (handoff.quantity ?? null)
      : quantity;

    if (
      savedQuantity !== null &&
      (!Number.isSafeInteger(savedQuantity) || savedQuantity < 1)
    ) {
      return false;
    }

    // Save only quote context and state, never contact-field values.
    const savedHandoff = {
      handoff_type: 'quote_form',
      product: handoff.product,
      quantity: savedQuantity,
      status
    };

    const previousContent = sourceMessage.content;

    sourceMessage.content =
      messages[status] +
      '\n<handoff>' +
      JSON.stringify(savedHandoff).replace(/</g, '\\u003c') +
      '</handoff>';

    try {
      saveSession();
      return true;
    } catch (error) {
      sourceMessage.content = previousContent;
      console.error('Could not save quote request state.');
      return false;
    }
  }

  function showQuoteForm(
    product,
    initialQuantity = null,
    sourceMessage = null
  ) {


    const uid = Date.now(); // unique per form instance
    const formDiv = document.createElement('div');
    formDiv.className = 'ai-quote-form';

    formDiv._quoteSourceMessage =
      sourceMessage?.role === 'assistant' &&
      sessionHistory.includes(sourceMessage)
        ? sourceMessage
        : null;

    formDiv._quotePromptElement = null;

    if (formDiv._quoteSourceMessage) {
      let candidate = thread().lastElementChild;

      if (candidate?.classList.contains('ai-start-over-link')) {
        candidate = candidate.previousElementSibling;
      }

      const normalisePromptText = value =>
        String(value || '').replace(/\s+/g, ' ').trim();

      if (
        candidate?.matches('.ai-bubble.assistant') &&
        normalisePromptText(candidate.textContent) ===
          normalisePromptText(stripTags(sourceMessage.content))
      ) {
        formDiv._quotePromptElement = candidate;
      }
    }

    formDiv.style.cssText = 'background:#F3F3F3;border:1px solid #E0E0E0;border-radius:8px;padding:16px;margin:12px 0;';
    formDiv.innerHTML = `
      <p class="ai-form-heading">
        Get a Formal Quote for
        <span style="color:#CC3333;">${escapeHtml(product.title)}</span>
      </p>

      <label for="q-name-${uid}">Your name</label>
      <input id="q-name-${uid}" autocomplete="name"
        required maxlength="200" />

      <label for="q-email-${uid}">Email address</label>
      <input id="q-email-${uid}" type="email" autocomplete="email"
        required maxlength="254" />

      <label for="q-company-${uid}">Company, optional</label>
      <input id="q-company-${uid}" autocomplete="organization"
        maxlength="200" />

      <label for="q-qty-${uid}">Quantity</label>
      <input id="q-qty-${uid}" type="number"
        min="1" step="1" required />

      <button id="q-submit-btn-${uid}" type="button">
        Send Me This Quote
      </button>
    `;

    thread().appendChild(formDiv);

    const requestedQuantity = Number(initialQuantity);
    if (
      Number.isSafeInteger(requestedQuantity) &&
      requestedQuantity > 0
    ) {
      document.getElementById(`q-qty-${uid}`).value = requestedQuantity;
    }

    scrollToBottom();
    document.getElementById(`q-submit-btn-${uid}`).addEventListener('click', () => {

      submitQuote(
        product.id,
        product.title,
        product.price,
        uid,
        product.selected_variant_id || '',
        product.matched_colour || ''
      );
    });
  }

  async function submitQuote(
    productId,
    productTitle,
    unitPrice,
    uid,
    selectedVariantId = '',
    matchedColour = ''
  ) {

    const button = document.getElementById(`q-submit-btn-${uid}`);
    const formDiv = button?.closest('.ai-quote-form');

    if (!formDiv || formDiv.dataset.quoteState) return;

    const nameInput = document.getElementById(`q-name-${uid}`);
    const emailInput = document.getElementById(`q-email-${uid}`);
    const companyInput = document.getElementById(`q-company-${uid}`);
    const quantityInput = document.getElementById(`q-qty-${uid}`);

    const name = nameInput.value.trim();
    const email = emailInput.value.trim();
    const company = companyInput.value.trim();
    const qty = Number(quantityInput.value);
    const price = Number(unitPrice);

    if (!name) {
      alert('Please enter your name.');
      nameInput.focus();
      return;
    }

    emailInput.value = email;
    if (!email || !emailInput.checkValidity()) {
      emailInput.reportValidity();
      emailInput.focus();
      return;
    }

    if (!Number.isSafeInteger(qty) || qty < 1) {
      alert('Please enter a whole-number quantity of at least 1.');
      quantityInput.focus();
      return;
    }

    if (qty > 500) {
      openBulkEnquiryFromQuote({
        productTitle,
        matchedColour,
        quantity: qty,
        name,
        email,
        company
      }, formDiv);
      return;
    }

    if (
      unitPrice === null ||

      unitPrice === undefined ||
      String(unitPrice).trim() === '' ||
      !Number.isFinite(price) ||
      price < 0
    ) {
      alert('The product price could not be verified. Please search again.');
      return;
    }

    let discount = 0;
    if (qty >= 51) discount = 20;
    else if (qty >= 26) discount = 15;
    else if (qty >= 11) discount = 10;
    else if (qty >= 4) discount = 5;

    const payload = {
      buyer_name: name,
      buyer_email: email,
      buyer_company: company,
      items: [{
        product_title: productTitle,
        product_id: String(productId || ''),
        variant_id: String(selectedVariantId || ''),
        variant: String(matchedColour || ''),
        quantity: qty,
        unit_price: price,
        discount_percent: discount
      }]
    };


    if (!setSavedQuoteState(formDiv, 'sending', qty)) {
      alert(
        'The quote request could not be safely started. ' +
        'No quote was submitted. Please refresh the page.'
      );
      return;
    }

    formDiv.dataset.quoteState = 'sending';

    const fields = formDiv.querySelectorAll('input');
    fields.forEach(field => { field.disabled = true; });
    button.disabled = true;
    button.textContent = 'Sending quote…';

    const loadingDiv = document.createElement('div');
    loadingDiv.className = 'ai-bubble assistant';
    loadingDiv.setAttribute('role', 'status');
    loadingDiv.textContent = 'Generating your quote...';
    thread().appendChild(loadingDiv);
    scrollToBottom();

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 30000);
    let canRetry = false;

    try {
      const res = await fetch(`${BACKEND}/quote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal
      });
      const result = await res.json();

      if (!res.ok) {
        const unconfirmed =
          typeof result?.detail === 'string' &&
          /could not be confirmed/i.test(result.detail);

        // Retry only explicit input-validation rejections.
        canRetry = !unconfirmed && [400, 422].includes(res.status);

        loadingDiv.textContent = canRetry
          ? 'Please check your details. The quote request was rejected.'
          : 'Quote delivery couldn’t be confirmed. Please contact the team before submitting again.';
      } else if (!result?.quote_id || !result?.email_sent_to) {
        loadingDiv.textContent =
          'Quote delivery couldn’t be confirmed. Please contact the team before submitting again.';
      } else {
        formDiv.dataset.quoteState = 'completed';
        loadingDiv.innerHTML =
          `Your quotation has been sent to <b>${escapeHtml(result.email_sent_to)}</b>. ` +
          'Please check your inbox!';
      }
    } catch (err) {
      loadingDiv.textContent =
        'Quote delivery couldn’t be confirmed. Please contact the team before submitting again.';
    } finally {
      clearTimeout(timer);

      if (canRetry && !setSavedQuoteState(formDiv, 'pending')) {
        canRetry = false;
        loadingDiv.textContent =
          'The request was rejected, but its saved state could not ' +
          'be updated. Please contact the team before trying again.';
      }

      if (!canRetry) {
        setSavedQuoteState(
          formDiv,
          formDiv.dataset.quoteState === 'completed'
            ? 'completed'
            : 'unconfirmed'
        );
      }

      if (canRetry) {

        delete formDiv.dataset.quoteState;
        fields.forEach(field => { field.disabled = false; });
        button.disabled = false;
        button.textContent = 'Send Me This Quote';
      } else if (formDiv.dataset.quoteState === 'completed') {
        button.textContent = 'Quote sent';
      } else {
        formDiv.dataset.quoteState = 'unconfirmed';
        button.textContent = 'Contact team before retrying';
      }

      if (loadingDiv.isConnected) scrollToBottom();
    }
  }

  // ── Email Collect ─────────────────────────────────────────────────────────

  function appendEmailCollect(sourceMessage) {
    if (!sourceMessage) return;

    const existing = thread().querySelector('.ai-email-collect');
    if (existing?.dataset.sending === 'true') return;
    if (existing) existing.remove();

    const wrapper = document.createElement('div');
    wrapper.className = 'ai-email-collect';
    wrapper.style.cssText =
      'background:#F3F3F3;border:1px solid #E0E0E0;' +
      'border-radius:8px;padding:16px;margin:12px 0;';

    wrapper.innerHTML = `
      <p style="font-weight:600;margin:0 0 10px;">
        Enter your email to send this enquiry to our team:
      </p>
      <input class="ec-email" type="email" required maxlength="254"
        autocomplete="email" placeholder="Your email address"
        style="width:100%;padding:8px;margin-bottom:10px;
        border:1px solid #E0E0E0;border-radius:4px;box-sizing:border-box;">
      <button class="ec-submit-btn" type="button"
        style="background:#CC3333;color:#fff;border:none;padding:10px 20px;
        border-radius:4px;cursor:pointer;font-weight:600;width:100%;">
        Notify Me
      </button>
      <div class="ec-status" role="status"
        style="margin-top:8px;font-size:13px;"></div>
      <div style="margin-top:8px;font-size:12px;">
        Alternatively, email
        <a href="mailto:ravikumar@dilsebol.com">ravikumar@dilsebol.com</a>.
      </div>
    `;

    const emailInput = wrapper.querySelector('.ec-email');
    const button = wrapper.querySelector('.ec-submit-btn');
    const status = wrapper.querySelector('.ec-status');

    button.addEventListener('click', async () => {
      if (wrapper.dataset.sending === 'true') return;
      if (!emailInput.reportValidity()) return;

      const email = emailInput.value.trim();
      const enquiryNotes = parseHandoff(sourceMessage.content)?.notes || '';
      const context = sessionHistory.slice(-4).map(message =>
        `${message.role}: ${stripTags(message.content)}`
      ).join('\n');

      wrapper.dataset.sending = 'true';
      button.disabled = true;
      status.textContent = 'Submitting your enquiry. Please don’t refresh yet.';

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 30000);
      let canRetry = true;

      try {
        const response = await fetch(`${BACKEND}/collect-lead`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email,
            notes: `${enquiryNotes}\n\nRecent conversation:\n${context}`
          }),
          signal: controller.signal
        });
        const result = await response.json();

        if (!wrapper.isConnected ||
            !sessionHistory.includes(sourceMessage)) return;

        if (!response.ok) {
          const detail = typeof result.detail === 'string' ? result.detail : '';
          if (/could not be confirmed/i.test(detail)) {
            canRetry = false;
            status.textContent =
              'Submission couldn’t be confirmed. Please contact the team before resubmitting.';
          } else {
            status.textContent =
              detail || 'Your enquiry wasn’t submitted. Please try again.';
          }
          return;
        }

        if (result.status !== 'ok' || !result.reference) {
          canRetry = false;
          status.textContent =
            'Submission couldn’t be confirmed. Please contact the team before resubmitting.';
          return;
        }

        // Don't reopen this completed email form after refresh.
        sourceMessage.content = sourceMessage.content.replace(
          /<collect_email\/>/g, ''
        );

        const acknowledgement =
          `Your enquiry has been submitted. ` +
          `Reference: **${escapeHtml(result.reference)}**. ` +
          `The team will send a reply to **${escapeHtml(email)}**.`;

        wrapper.remove();
        appendAssistantBubble(acknowledgement);
        sessionHistory.push({
          role: 'assistant',
          content: acknowledgement
        });
        saveSession();
      } catch (error) {
        canRetry = false;
        if (wrapper.isConnected) {
          status.textContent =
            'Submission couldn’t be confirmed. Please contact the team before resubmitting.';
        }
      } finally {
        clearTimeout(timer);
        wrapper.dataset.sending = 'false';
        button.disabled = !canRetry;
      }
    });

    thread().appendChild(wrapper);
    scrollToNewMessage(wrapper);
  }

  // ── Parsers ───────────────────────────────────────────────────────────────

  const productBatchQuantities = new WeakMap();

  function parseProducts(text) {
    const match = text.match(/<products>([\s\S]*?)<\/products>/);
    if (!match) return [];

    try {
      const products = JSON.parse(match[1].trim());

      if (Array.isArray(products)) {
        let requestedQuantity = null;
        const stateMatches = [
          ...text.matchAll(/<search_state>([\s\S]*?)<\/search_state>/g)
        ];

        if (
          stateMatches.length === 1 &&
          (text.match(/<products>/g) || []).length === 1
        ) {
          try {
            const state = JSON.parse(stateMatches[0][1]);

            if (
              state &&
              typeof state === 'object' &&
              !Array.isArray(state) &&
              state.version === 1 &&
              Number.isSafeInteger(state.quantity) &&
              state.quantity > 0
            ) {
              requestedQuantity = state.quantity;
            }
          } catch {
            // Invalid search state must not discard valid product cards.
          }
        }

        productBatchQuantities.set(products, requestedQuantity);
      }

      return products;
    } catch (e) {
      console.error('Failed to parse products JSON:', e);
      return [];
    }
  }

  function parseClarify(text) {
    const match = text.match(/<clarify>([\s\S]*?)<\/clarify>/);
    if (!match) return null;
    try {
      return JSON.parse(match[1].trim());
    } catch (e) {
      console.error('Failed to parse clarify JSON:', e, 'Raw:', match[1]);
      return null;
    }
  }

  function parseHandoff(text) {
    const match = text.match(/<handoff>([\s\S]*?)<\/handoff>/);
    if (!match) return null;
    try {
      return JSON.parse(match[1].trim());
    } catch (e) {
      console.error('Failed to parse handoff JSON:', e);
      return null;
    }
  }

  async function dispatchHandoff(handoff, sourceMessage = null) {
    // No-match enquiries are submitted only after Notify Me collects email.
    if (handoff.handoff_type === 'no_match') return;

    try {
      if (handoff.handoff_type === 'quote_form') {
        const product = handoff.product;
        const quantity = handoff.quantity;

        const validQuantity =
          quantity === null ||
          quantity === undefined ||
          (
            Number.isSafeInteger(quantity) &&
            quantity >= 1 &&
            quantity <= 500
          );

        const validProduct =
          product &&
          typeof product === 'object' &&
          typeof product.id === 'string' &&
          /^gid:\/\/shopify\/Product\/[1-9]\d*$/.test(product.id) &&
          typeof product.title === 'string' &&
          product.title.trim().length > 0 &&
          typeof product.price === 'number' &&
          Number.isFinite(product.price) &&
          product.price >= 0 &&
          typeof product.selected_variant_id === 'string' &&
          /^(?:[1-9]\d*|gid:\/\/shopify\/ProductVariant\/[1-9]\d*)$/.test(
            product.selected_variant_id
          ) &&
          (
            product.matched_colour === undefined ||
            typeof product.matched_colour === 'string'
          );

        if (!validProduct || !validQuantity) {
          appendAssistantBubble(
            'I couldn’t prepare the quote form from those details. ' +
            'Please choose a product card and use Email Formal Quote.'
          );
          return;
        }

        if ((handoff.status ?? 'pending') !== 'pending') {
          return;
        }

        showQuoteForm(
          product,
          quantity,
          sourceMessage ?? sessionHistory[sessionHistory.length - 1]
        );
        return;
      }

      if (handoff.handoff_type === 'formal_quote') {

        const resp = await fetch(`${BACKEND}/formal-quote`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(handoff)
        });
        const data = await resp.json();
        if (resp.ok && data.status === 'ok') {
          appendAssistantBubble(
            `✅ Your quote has been sent to **${handoff.customer_email}**. ` +
            `Please check your inbox — the PDF includes your pricing with any applicable volume discount.`
          );
        } else {
          appendAssistantBubble(
            `Sorry, there was an issue generating your quote. Please try again or contact us directly.`
          );
        }
      } else if (handoff.handoff_type === 'bulk_lead') {
        const payload = {
          buyer_name: handoff.buyer_name || handoff.customer_name || '',
          buyer_email: handoff.buyer_email || handoff.customer_email || '',
          buyer_phone: handoff.buyer_phone || handoff.customer_phone || '',
          buyer_company: handoff.buyer_company || handoff.customer_company || '',
          product_interest:
            handoff.product_interest || handoff.product_title || '',
          quantity: Number(handoff.quantity) || 0,
          message: handoff.message || handoff.notes || ''
        };

        if (!payload.buyer_name.trim() || !payload.buyer_email.trim()) {
          appendAssistantBubble(
            'Please provide your name and email address before submitting the enquiry.'
          );
          return;
        }

        let response;
        let result;

        try {
          response = await fetch(`${BACKEND}/handoff`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          result = await response.json();
        } catch (error) {
          appendAssistantBubble(
            'I couldn’t confirm that your enquiry was submitted. ' +
            'Please contact ravikumar@dilsebol.com before submitting it again.'
          );
          return;
        }

        if (!response.ok || result.status !== 'handoff_triggered') {
          const unconfirmed =
            typeof result.detail === 'string' &&
            /could not be confirmed/i.test(result.detail);

          appendAssistantBubble(
            unconfirmed
              ? 'I couldn’t confirm that your enquiry was submitted. ' +
                'Please contact ravikumar@dilsebol.com before submitting it again.'
              : 'Your enquiry wasn’t successfully submitted. ' +
                'Please try again or email ravikumar@dilsebol.com.'
          );
          return;
        }

        const acknowledgement =
          'Your enquiry has been submitted. ' +
          (result.reference
            ? `Reference: **${escapeHtml(result.reference)}**. `
            : '') +
          `The team will send a reply to **${escapeHtml(payload.buyer_email)}**.`;

        appendAssistantBubble(acknowledgement);
        sessionHistory.push({
          role: 'assistant',
          content: acknowledgement
        });
        saveSession();

      } else {
        await fetch(`${BACKEND}/handoff`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(handoff)
        });
      }

      console.log('Handoff dispatched:', handoff.handoff_type);
    } catch (e) {
      console.error('Handoff dispatch failed:', e);
    }
  }

  // ── Renderers ─────────────────────────────────────────────────────────────

  function appendUserBubble(text) {
    const el = document.createElement('div');
    el.className = 'ai-bubble user';
    el.textContent = text;
    thread().appendChild(el);
    scrollToBottom();
  }

  function appendAssistantBubble(text, render = true) {
    if (!text) return;
    const el = document.createElement('div');
    el.className = 'ai-bubble assistant';
    el.innerHTML = render ? formatText(text) : text;
    thread().appendChild(el);

    // Re-inject "Start over" after every real response, always at the bottom
    const hasUserMessage = thread().querySelector('.ai-bubble.user');
    if (hasUserMessage) {
      const existing = thread().querySelector('.ai-start-over-link');
      if (existing) existing.remove();
      const startOver = document.createElement('div');
      startOver.className = 'ai-start-over-link';
      startOver.style.cssText = 'text-align:right;margin:-4px 0 8px;';
      startOver.innerHTML = '<a href="#" style="font-size:13px;color:#CC3333;font-family:var(--font-body-family,sans-serif);font-weight:600;text-decoration:underline;letter-spacing:0.02em;">↺ Start over</a>';
      startOver.querySelector('a').addEventListener('click', (e) => {
        e.preventDefault();
        clearChat();
      });
      thread().appendChild(startOver);
    }
    
    syncHeaderStartOver();
    scrollToNewMessage(el);
    return el;
  }

  function appendLoadingBubble() {
    const el = document.createElement('div');
    el.className = 'ai-bubble loading';
    el.innerHTML = '<div class="ai-typing-dots"><span></span><span></span><span></span></div>';
    thread().appendChild(el);
    scrollToBottom();
    return el;
  }
  function renderCategoryPicker(clarify) {
    const options = [...new Set(
      [
        clarify?.options,
        clarify?.more_options,
        clarify?.remaining_options
      ]
        .flatMap(values => Array.isArray(values) ? values : [])
        .filter(value => typeof value === 'string')
        .map(value => value.trim())
        .filter(value => value.length > 0)
    )];

    if (options.length === 0) {
      appendAssistantBubble(
        'I couldn’t load the category choices. ' +
        'Please type the product category you’re interested in.'
      );
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.style.cssText =
      'display:flex;flex-direction:column;gap:8px;' +
      'margin:8px 0 12px;align-self:flex-start;width:90%;';

    const choiceGroup = document.createElement('div');
    choiceGroup.style.cssText =
      'display:flex;flex-direction:column;gap:6px;';

    const groupName =
      'ai-category-' + Date.now() + '-' +
      Math.random().toString(36).slice(2);

    const entries = [];
    const generation = chatGeneration;
    let selectedLabel = '';
    let offset = 0;
    let submitted = false;

    const moreBtn = document.createElement('button');
    moreBtn.type = 'button';
    moreBtn.style.cssText =
      'background:#F3F3F3;color:#555;border:1px solid #E0E0E0;' +
      'border-radius:8px;padding:8px 12px;cursor:pointer;' +
      'font-size:13px;font-family:var(--font-body-family,sans-serif);' +
      'align-self:flex-start;';

    const confirmBtn = document.createElement('button');
    confirmBtn.type = 'button';
    confirmBtn.textContent = 'Show me options →';
    confirmBtn.disabled = true;
    confirmBtn.style.cssText =
      'background:#E0E0E0;color:#888;border:none;' +
      'border-radius:8px;padding:10px 20px;' +
      'font-size:13px;font-weight:600;' +
      'font-family:var(--font-body-family,sans-serif);' +
      'cursor:not-allowed;align-self:flex-start;margin-top:4px;';

    function renderNextBatch() {
      if (submitted) return;

      const batch = options.slice(offset, offset + 10);

      batch.forEach(label => {
        const item = document.createElement('label');
        item.style.cssText =
          'display:flex;align-items:center;gap:8px;' +
          'padding:8px 12px;border:1.5px solid #E0E0E0;' +
          'border-radius:8px;cursor:pointer;font-size:13px;' +
          'font-family:var(--font-body-family,sans-serif);' +
          'color:#121212;background:#fff;';

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = groupName;
        radio.value = label;
        radio.style.cssText =
          'accent-color:#CC3333;width:16px;height:16px;flex-shrink:0;';

        radio.addEventListener('change', () => {
          if (
            submitted ||
            generation !== chatGeneration ||
            !wrapper.isConnected ||
            !radio.checked
          ) {
            return;
          }

          selectedLabel = label;

          entries.forEach(entry => {
            const chosen = entry.label === selectedLabel;
            entry.radio.checked = chosen;
            entry.item.style.borderColor =
              chosen ? '#CC3333' : '#E0E0E0';
            entry.item.style.background =
              chosen ? '#fff5f5' : '#fff';
            entry.item.style.color =
              chosen ? '#CC3333' : '#121212';
            entry.item.style.fontWeight =
              chosen ? '600' : 'normal';
          });

          confirmBtn.disabled = false;
          confirmBtn.style.background = '#CC3333';
          confirmBtn.style.color = '#fff';
          confirmBtn.style.cursor = 'pointer';
        });

        const span = document.createElement('span');
        span.textContent = label;

        item.appendChild(radio);
        item.appendChild(span);
        choiceGroup.appendChild(item);
        entries.push({ label, radio, item });
      });

      offset += batch.length;
      const remaining = options.length - offset;

      moreBtn.hidden = remaining === 0;
      moreBtn.textContent =
        `Show ${Math.min(10, remaining)} more categories`;
    }

    moreBtn.addEventListener('click', () => {
      if (
        submitted ||
        generation !== chatGeneration ||
        !wrapper.isConnected
      ) {
        return;
      }

      renderNextBatch();
    });

    confirmBtn.addEventListener('click', () => {
      if (
        submitted ||
        !selectedLabel ||
        chatInFlight ||
        generation !== chatGeneration ||
        !wrapper.isConnected
      ) {
        return;
      }

      submitted = true;

      entries.forEach(entry => {
        entry.radio.disabled = true;
        if (entry.label !== selectedLabel) {
          entry.item.style.opacity = '0.4';
        }
      });

      moreBtn.disabled = true;
      confirmBtn.disabled = true;
      confirmBtn.textContent = '✓ ' + selectedLabel;
      confirmBtn.style.background = '#CC3333';
      confirmBtn.style.color = '#fff';
      confirmBtn.style.cursor = 'default';

      sendMessage(selectedLabel);
    });

    wrapper.appendChild(choiceGroup);
    wrapper.appendChild(moreBtn);
    wrapper.appendChild(confirmBtn);
    thread().appendChild(wrapper);

    renderNextBatch();
    scrollToNewMessage(wrapper);
  }

  function appendClarifyButtons(clarify) {
    // ── Category picker ───────────────────────────────────────────────────
    if (clarify.clarify_type === 'category_picker') {
      renderCategoryPicker(clarify);
      return;
    }
    const wrapper = document.createElement('div');
    wrapper.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;margin:8px 0 12px;';

    // Combine all overflow batches into one flat queue
    const initialOptions = clarify.options || [];
    const overflowQueue = [
      ...(clarify.more_options || []),
      ...(clarify.remaining_options || []),
    ];

    function renderButtons(options) {
      options.forEach(option => {
        const btn = document.createElement('button');
        btn.textContent = option;
        btn.style.cssText = `
          background:#fff;
          color:#CC3333;
          border:1.5px solid #CC3333;
          padding:8px 16px;
          border-radius:20px;
          cursor:pointer;
          font-size:13px;
          font-weight:600;
          font-family:var(--font-body-family, sans-serif);
          transition:background 0.15s, color 0.15s;
        `;
        btn.addEventListener('mouseenter', () => {
          btn.style.background = '#CC3333';
          btn.style.color = '#fff';
        });
        btn.addEventListener('mouseleave', () => {
          btn.style.background = '#fff';
          btn.style.color = '#CC3333';
        });
        btn.addEventListener('click', () => {
            wrapper.querySelectorAll('button').forEach(b => b.disabled = true);
            btn.style.background = '#CC3333';
            btn.style.color = '#fff';
            const bucket = (clarify.bucket_data || []).find(
              item => item.label === option
            );

            const msg = bucket
              ? `Rs ${bucket.min_price} to Rs ${bucket.max_price}`
              : clarify.clarify_type === 'shade'
                ? `<shade_selected>${option}</shade_selected>`
                : clarify.clarify_type === 'colour'
                  ? `<colour_selected>${option}</colour_selected>`
                  : option;

            sendMessage(msg);
        });

        wrapper.appendChild(btn);
      });
    }

    function appendShowMoreBtn(queue, offset) {
      if (offset >= queue.length) return;
      const nextBatch = queue.slice(offset, offset + 10);
      const stillRemaining = queue.length - offset - nextBatch.length;
      const moreBtn = document.createElement('button');
      if (clarify.clarify_type === 'ambiguity') {
        moreBtn.textContent = 'Others →';
      } else {
        moreBtn.textContent = stillRemaining > 0
          ? `+ Show next 10 (${stillRemaining} more after)`
          : `+ Show ${nextBatch.length} more colours`;
      }

      moreBtn.style.cssText = `
        background:#F3F3F3;
        color:#888888;
        border:1.5px solid #E0E0E0;
        padding:8px 16px;
        border-radius:20px;
        cursor:pointer;
        font-size:13px;
        font-weight:600;
        font-family:var(--font-body-family, sans-serif);
      `;
      moreBtn.addEventListener('click', () => {
        moreBtn.remove();
        renderButtons(nextBatch);
        appendShowMoreBtn(queue, offset + nextBatch.length);
        scrollToBottom();
      });
      wrapper.appendChild(moreBtn);
    }

    renderButtons(initialOptions);
    appendShowMoreBtn(overflowQueue, 0);

    thread().appendChild(wrapper);

    // Hint text — only for colour clarify, not ambiguity or category
    if (clarify.clarify_type === 'colour' || clarify.clarify_type === 'shade') {
      const hint = document.createElement('div');
      hint.style.cssText = 'font-size:13px;color:#888888;margin:-6px 0 10px;font-family:var(--font-body-family,sans-serif);';
      hint.textContent = 'You can also type your preferred colour directly.';
      thread().appendChild(hint);
    }

    scrollToNewMessage(wrapper);    
  }

  function mockupIntro(text) {
    return text.replace(
      /For each product,[\s\S]*/i,
      'Choose the product you’d like to preview or request a mock-up for.'
    );
  }

  function finishMockupChoice() {
    sessionStorage.removeItem(MOCKUP_STATE_KEY);
    const result = [...sessionHistory].reverse().find(m =>
      m.role === 'assistant' && m.content.includes('<mockup_choices/>')
    );
    if (result) {
      result.content = result.content.replace(
        '<mockup_choices/>', '<mockup_finished/>'
      );
      saveSession();
    }
    thread().querySelectorAll('.ai-request-mockup').forEach(b => {
      b.disabled = true;
    });
  }
  function showMockupRequestForm(p) {
    const choiceReply = [...sessionHistory].reverse().find(m =>
      m.role === 'assistant' && m.content.includes('<mockup_choices/>')
    );
    if (!choiceReply) return;

    const existing = thread().querySelector('.ai-mockup-request-form');
    if (existing && existing.dataset.sending === 'true') {
      scrollToNewMessage(existing);
      return;
    }
    if (existing) existing.remove();

    const colour = p.matched_colour || '';
    const selectedOption = [
      colour ? `Colour: ${colour}` : '',
      p.selected_variant_id ? `Variant ID: ${p.selected_variant_id}` : ''
    ].filter(Boolean).join(' | ');

    const form = document.createElement('form');
    form.className = 'ai-bubble assistant ai-mockup-request-form';
    form.innerHTML = `
      <div><strong>Request a mock-up</strong></div>
      <div style="margin:8px 0;">
        ${escapeHtml(p.title)}<br>
        Selected colour: ${escapeHtml(colour || 'Not specified')}
      </div>
      <label style="display:block;margin:8px 0;">
        Reply email
        <input name="replyEmail" type="email" required maxlength="254"
          autocomplete="email"
          style="display:block;box-sizing:border-box;width:100%;padding:8px;">
      </label>
      <label style="display:block;margin:8px 0;">
        Logo, PNG/JPG/WebP, maximum 5 MB
        <input name="logo" type="file" required
          accept=".png,.jpg,.jpeg,.webp"
          style="display:block;margin-top:4px;max-width:100%;">
      </label>
      <label style="display:block;margin:8px 0;">
        Additional details, optional
        <textarea name="notes" maxlength="1000" rows="2"
          placeholder="Print position or any other instructions"
          style="display:block;box-sizing:border-box;width:100%;padding:8px;"></textarea>
      </label>
      <div style="font-size:12px;margin:8px 0;">
        Submitting shares your logo and reply email with the DilSeBol team.
      </div>
      <button type="submit" class="ai-card-btn">Submit mock-up request</button>
      <div class="ai-mockup-status" role="status"
        style="margin-top:8px;font-size:13px;"></div>
      <div style="font-size:12px;margin-top:8px;">
        Prefer email? Send your logo and product details to
        <a href="mailto:ravikumar@dilsebol.com">ravikumar@dilsebol.com</a>.
      </div>
    `;

    const submitButton = form.querySelector('[type="submit"]');
    const status = form.querySelector('.ai-mockup-status');

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (form.dataset.sending === 'true') return;

      if (!choiceReply.content.includes('<mockup_choices/>')) {
        status.textContent = 'This product choice has finished. Start a new mock-up request.';
        submitButton.disabled = true;
        return;
      }

      const email = form.elements.replyEmail.value.trim();
      const file = form.elements.logo.files[0];

      if (!file) {
        status.textContent = 'Choose a logo image.';
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        status.textContent = 'Your logo must be 5 MB or smaller.';
        return;
      }

      const payload = new FormData();
      payload.append('product_id', String(p.id));
      payload.append('product_title', p.title);
      payload.append('variant', selectedOption);
      payload.append('buyer_email', email);
      payload.append('notes', form.elements.notes.value.trim());
      payload.append('logo', file);

      form.dataset.sending = 'true';
      submitButton.disabled = true;
      status.textContent = 'Sending your request. Please don’t refresh yet.';

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 30000);
      let canRetry = true;

      try {
        const response = await fetch(`${BACKEND}/mockup-request`, {
          method: 'POST',
          body: payload,
          signal: controller.signal
        });
        const data = await response.json();

        if (!form.isConnected) return;

        if (!response.ok) {
          const detail = typeof data.detail === 'string' ? data.detail : '';
          if (/could not be confirmed/i.test(detail)) {
            canRetry = false;
            status.textContent =
              'We couldn’t confirm submission. Please contact the team before resubmitting.';
          } else if (response.status === 429) {
            status.textContent =
              'Too many attempts. Please try later or use the email option below.';
          } else {
            status.textContent =
              detail || 'Request failed. Your details remain here so you can retry.';
          }
          return;
        }

        if (data.status !== 'accepted' || !data.reference) {
          canRetry = false;
          status.textContent =
            'We couldn’t confirm submission. Please contact the team before resubmitting.';
          return;
        }

        // Finish only this choice, not a newer mock-up conversation.
        const latestChoice = [...sessionHistory].reverse().find(m =>
          m.role === 'assistant' && m.content.includes('<mockup_choices/>')
        );
        if (latestChoice === choiceReply) finishMockupChoice();

        const acknowledgement =
          `Your mock-up request for **${escapeHtml(p.title)}** has been submitted. ` +
          `Reference: **${escapeHtml(data.reference)}**. ` +
          `The team will send a reply to **${escapeHtml(email)}**.`;

        form.remove();
        appendAssistantBubble(acknowledgement);
        sessionHistory.push({
          role: 'assistant',
          content: acknowledgement
        });
        saveSession();
      } catch (error) {
        canRetry = false;
        if (form.isConnected) {
          status.textContent =
            'We couldn’t confirm submission. Please contact the team before resubmitting.';
        }
      } finally {
        clearTimeout(timer);
        form.dataset.sending = 'false';
        submitButton.disabled = !canRetry;
      }
    });

    thread().appendChild(form);
    scrollToNewMessage(form);
  }

  function parseBulkEnquiry(text) {
    const match = text.match(/<bulk_enquiry>([\s\S]*?)<\/bulk_enquiry>/);
    if (!match) return null;
    try {
      return JSON.parse(match[1]);
    } catch (error) {
      return null;
    }
  }

  function setBulkEnquiryStatus(message, status) {
    const enquiry = parseBulkEnquiry(message.content);
    if (!enquiry) return;
    enquiry.status = status;
    message.content = message.content.replace(
      /<bulk_enquiry>[\s\S]*?<\/bulk_enquiry>/,
      () => `<bulk_enquiry>${JSON.stringify(enquiry)}</bulk_enquiry>`
    );
  }

  function retirePendingBulkEnquiries() {
    sessionHistory.forEach(message => {
      if (parseBulkEnquiry(message.content)?.status === 'pending') {
        setBulkEnquiryStatus(message, 'cancelled');
      }
    });
    thread().querySelectorAll('.ai-bulk-enquiry-form').forEach(form => {
      form.remove();
    });
    saveSession();
  }

  function openBulkEnquiryFromQuote(details, quoteForm) {
    if (
      !setSavedQuoteState(
        quoteForm,
        'retired',
        details.quantity
      )
    ) {
      alert(
        'The quote form could not be safely transferred. ' +
        'No enquiry was submitted. Please refresh the page.'
      );
      return;
    }

    quoteForm.dataset.quoteState = 'retired';

    quoteForm._quotePromptElement?.remove();

    retirePendingBulkEnquiries();

    const option = String(details.matchedColour || '').trim();
    const enquiry = {
      enquiry:
        details.productTitle + (option ? ` — ${option}` : ''),
      quantity: details.quantity,
      status: 'pending'
    };

    const introduction =
      'For quantities above 500 units, the team will prepare your quotation. ' +
      'Please review your details and add your phone number below. ' +
      'Nothing has been submitted yet.';

    const enquiryJson = JSON.stringify(enquiry).replace(/</g, '\\u003c');
    const sourceMessage = {
      role: 'assistant',
      content:
        introduction +
        '\n<bulk_enquiry>' + enquiryJson + '</bulk_enquiry>'
    };

    sessionHistory.push(sourceMessage);
    saveSession();

    quoteForm.remove();
    appendAssistantBubble(introduction);
    showBulkEnquiryForm(enquiry, sourceMessage);

    const bulkForm = thread().querySelector('.ai-bulk-enquiry-form');
    if (bulkForm) {
      bulkForm.elements.buyerName.value = details.name;
      bulkForm.elements.buyerEmail.value = details.email;
      bulkForm.elements.buyerCompany.value = details.company;
    }
  }

  function showBulkEnquiryForm(enquiry, sourceMessage) {

    if (enquiry.status !== 'pending') return;

    const form = document.createElement('form');
    form.className = 'ai-bubble assistant ai-bulk-enquiry-form';
    form.innerHTML = `
      <div><strong>Your enquiry</strong></div>
      <div style="margin:8px 0;">
        ${escapeHtml(enquiry.enquiry)}<br>
        Quantity: ${escapeHtml(String(enquiry.quantity))} units
      </div>
      <label style="display:block;margin:8px 0;">
        Name
        <input name="buyerName" required maxlength="200"
          autocomplete="name"
          style="display:block;box-sizing:border-box;width:100%;padding:8px;">
      </label>
      <label style="display:block;margin:8px 0;">
        Email
        <input name="buyerEmail" type="email" required maxlength="254"
          autocomplete="email"
          style="display:block;box-sizing:border-box;width:100%;padding:8px;">
      </label>
      <label style="display:block;margin:8px 0;">
        Phone
        <input name="buyerPhone" type="tel" required maxlength="30"
          autocomplete="tel"
          style="display:block;box-sizing:border-box;width:100%;padding:8px;">
      </label>
      <label style="display:block;margin:8px 0;">
        Company, optional
        <input name="buyerCompany" maxlength="200"
          autocomplete="organization"
          style="display:block;box-sizing:border-box;width:100%;padding:8px;">
      </label>
      <label style="display:block;margin:8px 0;">
        Additional details, optional
        <textarea name="notes" rows="2" maxlength="1000"
          style="display:block;box-sizing:border-box;width:100%;padding:8px;"></textarea>
      </label>
      <div style="font-size:12px;margin:8px 0;">
        Submitting shares these details with the DilSeBol team.
      </div>
      <button type="submit" class="ai-card-btn">Submit Bulk Enquiry</button>
      <div class="ai-bulk-status" role="status"
        style="margin-top:8px;font-size:13px;"></div>
      <div style="font-size:12px;margin-top:8px;">
        Alternatively, email
        <a href="mailto:ravikumar@dilsebol.com">ravikumar@dilsebol.com</a>.
      </div>
    `;

    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('.ai-bulk-status');

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.sending === 'true') return;
      if (parseBulkEnquiry(sourceMessage.content)?.status !== 'pending') {
        return;
      }

      const email = form.elements.buyerEmail.value.trim();
      const payload = {
        buyer_name: form.elements.buyerName.value.trim(),
        buyer_email: email,
        buyer_phone: form.elements.buyerPhone.value.trim(),
        buyer_company: form.elements.buyerCompany.value.trim(),
        product_interest: enquiry.enquiry,
        quantity: enquiry.quantity,
        message: form.elements.notes.value.trim()
      };

      if (!payload.buyer_name || !email || !payload.buyer_phone) {
        status.textContent = 'Please enter your name, email and phone.';
        return;
      }

      form.dataset.sending = 'true';
      button.disabled = true;
      status.textContent = 'Submitting your enquiry. Please don’t refresh yet.';
      setLoading(true);

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 30000);
      let canRetry = true;

      try {
        const response = await fetch(`${BACKEND}/handoff`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: controller.signal
        });
        const result = await response.json();

        if (!form.isConnected || !sessionHistory.includes(sourceMessage)) {
          return;
        }

        if (!response.ok) {
          const detail = typeof result.detail === 'string' ? result.detail : '';
          if (/could not be confirmed/i.test(detail)) {
            canRetry = false;
            status.textContent =
              'Submission couldn’t be confirmed. Please contact the team before resubmitting.';
          } else {
            status.textContent =
              'Your enquiry wasn’t submitted successfully. Your details remain here so you can retry.';
          }
          return;
        }

        if (result.status !== 'handoff_triggered' || !result.reference) {
          canRetry = false;
          status.textContent =
            'Submission couldn’t be confirmed. Please contact the team before resubmitting.';
          return;
        }

        setBulkEnquiryStatus(sourceMessage, 'completed');

        const acknowledgement =
          `Your enquiry for **${enquiry.quantity} units** has been submitted. ` +
          `Reference: **${escapeHtml(result.reference)}**. ` +
          `The team will send a reply to **${escapeHtml(email)}**.`;

        form.remove();
        appendAssistantBubble(acknowledgement);
        sessionHistory.push({
          role: 'assistant',
          content: acknowledgement
        });
        saveSession();
      } catch (error) {
        canRetry = false;
        if (form.isConnected) {
          status.textContent =
            'Submission couldn’t be confirmed. Please contact the team before resubmitting.';
        }
      } finally {
        clearTimeout(timer);
        form.dataset.sending = 'false';
        button.disabled = !canRetry;
        setLoading(false);
      }
    });

    const t = thread();
    const bubbles = t.querySelectorAll('.ai-bubble.assistant');
    const introduction = bubbles[bubbles.length - 1];

    t.appendChild(form);

    requestAnimationFrame(() => {
      const anchor = introduction || form;
      t.scrollTop = Math.max(
        0,
        t.scrollTop +
        anchor.getBoundingClientRect().top -
        t.getBoundingClientRect().top -
        20
      );
    });

  }

  // ── FIX: appendProductCards now owns its own allProducts + offset ─────────
  function appendProductCards(allProducts, totalCount, startOffset) {
    if (!allProducts || allProducts.length === 0) return;

    const mockupChoice =
      sessionStorage.getItem(MOCKUP_STATE_KEY) === 'choosing_product';

    let localOffset = startOffset;

    const localProducts = allProducts;

    function renderBatch(offset) {
      const batch = localProducts.slice(offset, offset + PAGE_SIZE);
      if (!batch.length) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'ai-product-cards';

      batch.forEach(p => {
        const colourParam = p.matched_colour
          ? `&dil_colour=${encodeURIComponent(p.matched_colour)}`
          : '';
        const viewUrl = p.selected_variant_id
          ? `${p.product_url}?variant=${p.selected_variant_id}${colourParam}`
          : p.product_url;

        const shareUrl = p.selected_variant_id
          ? `${p.product_url}?variant=${p.selected_variant_id}`
          : p.product_url;

        const shareDescription = p.description
          ? `${p.title} — ${p.description}\n\n${shareUrl}`
          : `${p.title}\n\n${shareUrl}`;

        const moqHtml = p.moq
          ? `<div class="ai-product-moq" style="font-size:12px;color:#CC3333;font-weight:600;margin-top:2px;">Min. order: ${p.moq} units</div>`
          : `<div class="ai-product-moq" style="font-size:12px;color:#888888;font-weight:600;margin-top:2px;">No Min. Order Qty</div>`;

        const card = document.createElement('div');
        card.className = 'ai-product-card';
        card.innerHTML = `
          <div class="ai-card-main">
            <div class="ai-card-left">
              ${p.image_url ? `<img src="${p.image_url}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}
              <div class="ai-product-info">
                <div class="ai-product-title">${escapeHtml(p.title)}</div>
                <div class="ai-product-price">Rs.${p.price} per unit</div>
                ${moqHtml}
              </div>
            </div>
            <div class="ai-card-right">
              <button class="tier-toggle-btn" onclick="
                var w = this.nextElementSibling;
                w.classList.toggle('expanded');
                this.textContent = w.classList.contains('expanded') ? 'Hide pricing tiers ▲' : 'Show pricing tiers ▼';
              ">Show pricing tiers ▼</button>
              <div class="tier-table-wrapper">
                <div class="ai-pricing-tiers">
                  <div class="ai-tier-row ai-tier-header">
                    <span>Qty</span><span>Discount</span>
                  </div>
                  <div class="ai-tier-row"><span>1–3 units</span><span>NA</span></div>
                  <div class="ai-tier-row"><span>4–10 units</span><span>5% off</span></div>
                  <div class="ai-tier-row"><span>11–25 units</span><span>10% off</span></div>
                  <div class="ai-tier-row"><span>26–50 units</span><span>15% off</span></div>
                  <div class="ai-tier-row"><span>51+ units</span><span>20% off</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="ai-card-actions">
            
            <button class="ai-card-btn dil-view-btn" data-url="${viewUrl.includes('?') ? viewUrl + '&ref=assistant' : viewUrl + '?ref=assistant'}">View Details &amp; Order &#8599;</button>
            ${p.preview_configured === true &&
              ['Multi file Product Preview', 'Single file Product Preview']
                .includes(p.preview_route)
              ? `
                <span style="position:relative;display:inline-block;vertical-align:middle;">
                  <button class="ai-card-btn dil-preview-btn" type="button">View Preview &#8599;</button>
                  <details class="dil-preview-info" style="position:absolute;top:-16px;right:-7px;z-index:20;">
                    <summary
                      aria-label="About View Preview"
                      style="list-style:none;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;border:2px solid #111;border-radius:50%;background:#fff;color:#111;font-style:normal;font-weight:700;font-size:12px;line-height:1;"
                    >i</summary>
                    <span role="tooltip" style="position:absolute;bottom:calc(100% + 8px);right:-4px;z-index:30;box-sizing:border-box;width:220px;max-width:calc(100vw - 40px);padding:9px 11px;border-radius:6px;background:#222;color:#fff;font-size:11px;font-weight:400;line-height:1.45;text-align:left;white-space:normal;overflow-wrap:break-word;box-shadow:0 2px 8px rgba(0,0,0,.2);">
                      Opens a sample preview automatically.
                    </span>
                  </details>
                </span>
              `
              : ''}

            <button class="ai-card-btn" data-quote-title="${escapeAttr(p.title)}" data-quote-price="${p.price}">Email Formal Quote</button>
            <button class="ai-card-btn" data-share-url="${escapeAttr(shareUrl)}" data-share-text="${escapeAttr(shareDescription)}">Share with Team</button>
          </div>
        `;

        card.querySelector('[data-quote-title]').addEventListener('click', () => {
          showQuoteForm(
            p,
            productBatchQuantities.get(localProducts) ?? null
          );
        });

        card.querySelector('[data-share-url]').addEventListener('click', (e) => {
          const url = e.currentTarget.getAttribute('data-share-url');
          const text = e.currentTarget.getAttribute('data-share-text');
          shareProduct(url, text);
        });
        card.querySelector('.dil-view-btn').addEventListener('click', () => {
          sessionStorage.setItem('dilsebol_ref', 'assistant');
          window.open(card.querySelector('.dil-view-btn').dataset.url, '_blank');
        });

        const previewButton = card.querySelector('.dil-preview-btn');
        if (previewButton) {
          previewButton.addEventListener('click', () => {
            const productUrl = new URL(
              card.querySelector('.dil-view-btn').dataset.url,
              window.location.origin
            );
            productUrl.searchParams.set('dil_preview', '1');
            window.open(productUrl.toString(), '_blank', 'noopener');
          });
        }

        if (mockupChoice) {
          const actions = card.querySelector('.ai-card-actions');

          if (previewButton) {
            actions.prepend(previewButton.closest('span'));
            previewButton.addEventListener('click', finishMockupChoice, {
              once: true
            });
          } else {
            const requestButton = document.createElement('button');
            requestButton.type = 'button';
            requestButton.className = 'ai-card-btn ai-request-mockup';
            requestButton.textContent = 'Request for mock-up';

            requestButton.addEventListener('click', () => {
              showMockupRequestForm(p);
            });


            actions.prepend(requestButton);
          }
        }

        wrapper.appendChild(card);

      });        

      thread().appendChild(wrapper);

      localOffset = offset + batch.length;
      const remaining = totalCount - localOffset;

      if (remaining > 0) {
        const paginationBar = document.createElement('div');
        paginationBar.style.cssText = 'display:flex;align-items:center;justify-content:space-between;margin:8px 0 16px;';
        paginationBar.innerHTML = `
          <span style="font-size:12px;color:#888888;">
            Showing ${localOffset} of ${totalCount}
          </span>
          <button class="load-more-btn" style="
            background:#fff;
            color:#CC3333;
            border:1.5px solid #CC3333;
            padding:7px 16px;
            border-radius:20px;
            cursor:pointer;
            font-size:13px;
            font-weight:600;
            font-family:var(--font-body-family, sans-serif);
          ">Load next ${Math.min(remaining, PAGE_SIZE)} →</button>
        `;
        thread().appendChild(paginationBar);

        paginationBar.querySelector('.load-more-btn').addEventListener('click', () => {
          paginationBar.remove();
          renderBatch(localOffset);
          scrollToBottom();
        });
      } else if (totalCount > PAGE_SIZE) {
        const doneBar = document.createElement('div');
        doneBar.style.cssText = 'font-size:12px;color:#888888;margin:4px 0 16px;';
        doneBar.textContent = `Showing all ${totalCount} products`;
        thread().appendChild(doneBar);
      }
      
    }

    renderBatch(startOffset);
  }
  
  // ── Public action handlers ────────────────────────────────────────────────

  function requestMockup(productId, productTitle) {
  sendMessage('I would like a mock-up');
}

  function requestQuote(productId, productTitle) {
    let product = { id: productId, title: productTitle, price: 0 };
    for (let i = sessionHistory.length - 1; i >= 0; i--) {
      const msg = sessionHistory[i];
      if (msg.role === 'assistant') {
        const products = parseProducts(msg.content);
        const found = products.find(p => p.id === productId);
        if (found) { product = found; break; }
      }
    }
    showQuoteForm(product);
  }

  function shareProduct(productUrl, shareText) {
    const text = shareText || productUrl;
    if (navigator.share) {
      navigator.share({ title: 'DilSeBol Product', text, url: productUrl });
    } else {
      navigator.clipboard.writeText(text);
      appendAssistantBubble('Product link copied to clipboard!', false);
    }
  }

  // ── Utilities ─────────────────────────────────────────────────────────────

  function formatText(text) {
    return text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br>');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(str) {
    return String(str).replace(/'/g, "\\'").replace(/"/g, '&quot;');
  }

  function setLoading(state) {
    sendBtn().disabled = state;
    sendBtn().textContent = state ? '...' : 'Send';
  }

  function scrollToBottom() {
    const t = thread();
    t.scrollTop = t.scrollHeight;
  }

  function scrollToNewMessage(el) {
    if (!el) return;
    const t = thread();
    t.scrollTop = el.offsetTop - t.getBoundingClientRect().top + t.scrollTop - 20;
}

  function saveSession() {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionHistory.slice(-20)));
  }

  document.addEventListener('DOMContentLoaded', init);

  return { sendMessage, requestMockup, requestQuote, shareProduct, clearChat };
})();
